import React from 'react';
import loadingStyle from '../LoadingOverlay.module.css';

const Content = (props) => (

    <div className={loadingStyle.content}>
        {props.children}
    </div>
)

export default Content;
